import { Buffer } from 'buffer';
import Cookies from 'universal-cookie';

export const platformUploadJWT = (token) => {
    const cookies = new Cookies();
    cookies.set('platformAccessToken', token, { path: '/' });
    return cookies.get('platformAccessToken');
}

export const platformGetToken = () => {
    const cookies = new Cookies();
    return cookies.get('platformAccessToken');
}

export const revokePlatformToken = () => {
    const cookies = new Cookies();
    cookies.remove('platformAccessToken', { path: '/' });
    return true;
}

export const platformGetDecodedToken = (token = platformGetToken()) => {
    try {
        if(token) {
            let tokenObj = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
            return tokenObj;
        }
        return false;
    } catch (error) {
        console.log(`Unable to parse platform token. Invalid format ${token} with error ${error}`);
        return false;
    }
}